import { combineReducers, Reducer, AnyAction } from 'redux';

import {
  LOGOUT,
  UserState,
  UserNavState,
  SignInState,
  LightboxState,
  ProjectState,
  SignUpState,
  AuthState,
  LocaleState,
  ProfileState,
  TranslationState,
  NavigatorState,
  VerseEditorState,
  AlignmentState,
} from '../types';

import users from './user';
import lightbox from './lightbox';
import signin from './signin';
import project from './project';
import signup from './signup';
import usernav from './usernav';
import auth from './auth';
import locale from './locale';
import profile from './profile';
import translation from './translation';
import navigator from './navigator';
import verseEditor from './verseEditor';
import alignment from './alignment';

export interface WholeAppState {
  users: UserState;
  lightbox: LightboxState;
  signin: SignInState;
  project: ProjectState;
  signup: SignUpState;
  usernav: UserNavState;
  auth: AuthState;
  locale: LocaleState;
  profile: ProfileState;
  translation: TranslationState;
  navigator: NavigatorState;
  verseEditor: VerseEditorState;
  alignment: AlignmentState;
}
const appReducer = combineReducers({
  users,
  lightbox,
  signin,
  project,
  signup,
  usernav,
  auth,
  locale,
  profile,
  translation,
  navigator,
  verseEditor,
  alignment,
});

const rootAppReducer: Reducer<any, AnyAction> = (
  state: WholeAppState | undefined,
  action: any,
): any => {
  if (action.type === LOGOUT) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootAppReducer;
export type AppState = ReturnType<typeof rootAppReducer>;
